import Grid from "@mui/material/Grid2";
import MVP from "../mvp/MVP-Assets";

export default function SplashPage(props) {
  return (
    (<Grid container>
      <Grid size={12}>
        <MVP {...props} />
      </Grid>
    </Grid>)
  );
}